import { apiRequestWithChecks } from "./api";

export const escalation = {
  getLevels: function (token, messageTypes) {
    // messageTypes expected as comma-delimited string e.g. "text,email,voice"
    const query = encodeURIComponent(messageTypes || "");
    return apiRequestWithChecks(
      "GET",
      "/api/alerts/escalation-levels/options?messageTypes=" + query,
      {
        Authorization: "Bearer " + token,
      }
    );
  },
};
